import React from "react";
import { Box, Typography } from "@mui/material";
import { FEATURES } from "../constants";
import FeatureItem from "./FeatureItem";
import { Grid } from "@mui/material";

const HeaderBanner = ({ vitaStep }) => {
  const getTitle = () => {
    switch (vitaStep) {
      case 0:
        return "Mobility Life per te Vita";
      case 1:
        return "Personalizza le tue Garanzie";
      case 2:
        return "Completa i tuoi Dati";
      default:
        return "Mobility Life per te Vita";
    }
  };

  const getSubtitle = () => {
    switch (vitaStep) {
      case 0:
        return "Polizza vita modulare 100% online";
      case 1:
        return "Età: 18 anni - Regola capitale e durata";
      case 2:
        return "Ultimi passi per il preventivo finale";
      default:
        return "Polizza vita modulare 100% online";
    }
  };

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #13b86d, #10ac7d)",
        color: "white",
        py: 5,
        px: 4,
        textAlign: "center",
        borderRadius: 3,
        mb: 4,
        boxShadow: "0 8px 32px rgba(19, 184, 109, 0.2)",
      }}
    >
      <Typography variant="h4" fontWeight={700} gutterBottom>
        {getTitle()}
      </Typography>
      <Typography variant="body1" sx={{ opacity: 0.9, mb: 3 }}>
        {getSubtitle()}
      </Typography>

      {vitaStep === 0 && (
        <Grid container spacing={8} justifyContent="center">
          {FEATURES.map((feature, index) => (
            <FeatureItem key={index} text={feature} />
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default HeaderBanner;
